module.exports = __webpack_public_path__ + "static/img/progress-lock-modal.2af02a1.svg";